import { PaginationState } from "@tanstack/react-table";
import { format, isValid, parseISO } from "date-fns";
import { Field, Form, Formik, FormikErrors } from "formik";
import { nanoid } from "nanoid";
import { useEffect, useRef, useState } from "react";
import { useBlocker, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { EmptyListPlaceholderContent } from "../../shared/Ui/EmptyPageBlock";
import SelectCustomFormik from "../../shared/Ui/SelectCustom/SelectCustomFormik";
import Pagination from "../../shared/components/Table/Pagination";
import style from "./index.module.css";
import InputMask from "react-input-mask";
import AlertBox from "../../shared/Ui/AlertBox/AlertBox";
import ModalButton from "../../shared/Ui/Buttons/ModalButtons";
import Loader from "../../shared/Ui/Loader/Loader";
import ModalComponent from "../../shared/Ui/ModalComponent/ModalWindow";
import { useAppDispatch, useAppSelector } from "../../shared/hook";
import { useTranslation } from "react-i18next";
import { clearBlocker, setBlocker } from "../../shared/slice/blockerSlice";
import { SkeletonTheme } from "react-loading-skeleton";
import MockSkeleton from "./utils/MockSkeleton";
import ActionDropwdownCell from "../../shared/components/Table/ActionDropwdownCell";
import { Tooltip } from "react-tooltip";
import { deleteUser, getUserList, registerUser, RegistrationRequest, updateUser } from "../../common/api/userCreateApi";
import { FaExclamationCircle } from "react-icons/fa";
import StatusBadge from "../../shared/Ui/StatusBadge/StatusBadge";
import PageNotRole from "../../shared/Ui/PageNotFound/PageNotRole";
import { createTradePoint, deleteTradePoint, getTradePointList, updateTradePoint, TradePointRequest } from "../../common/api/tradePointApi";
import { log } from "node:console";

function RegistrationTradePoint() {
    const navigate = useNavigate();
    const roleUser = useAppSelector((state) => state.auth.userData.roles[0]?.name);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [alertOpen, setAlertOpen] = useState<any>(null);
    const [isFormChanged, setIsFormChanged] = useState(false);
    const [isOpen1, setIsOpen1] = useState(true);
    const [tradePointEditModal, setTradePointEditModal] = useState<any>(null);
    const [tradePointDelete, setTradePointDelete] = useState<any>(null);
    const [activeTooltipId, setActiveTooltipId] = useState<number | null>(null);
    const [tradePointData, setTradePointData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [initialValues, setInitialValues] = useState<TradePointRequest>({
        name: "",
        bin: "",
        address: "",
        phone: "",
        email: "",
        disabled: false,
        role: "",
    });

    const formValidationSchema = Yup.object().shape({
        name: Yup.string()
            .required("Поле обязательно для заполнения")
            .min(2, "Минимум 2 символа")
            .max(50, "Максимум 50 символов"),
        bin: Yup.string()
            .required("Поле обязательно для заполнения")
            .matches(/^\d{12}$/, "БИН должен содержать 12 цифр"),
        address: Yup.string()
            .required("Поле обязательно для заполнения")
            .min(5, "Минимум 5 символов")
            .max(200, "Максимум 200 символов"),
        phone: Yup.string()
            .required("Поле обязательно для заполнения")
            .matches(/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/, "Неверный формат телефона"),
        email: Yup.string()
            .email("Некорректный адрес электронной почты")
            .required("Поле обязательно для заполнения"),
        
    });

    const fetchTradePoints = async () => {
        try {
            setIsLoading(true);
            const data = await getTradePointList();
            console.log('Response from backend:', data);
            setTradePointData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Ошибка при получении списка торговых точек:", error);
            setTradePointData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchTradePoints();
    }, []);

    const handleTooltipToggle = (id: number) => {
        setActiveTooltipId((prevId) => (prevId === id ? null : id));
    };

    async function submitCreate(formikValues: TradePointRequest, resetForm: any) {
        try {
            await createTradePoint(formikValues);
            setAlertOpen({
                status: "SUCCESS",
                message: "Торговая точка успешно создана",
            });
            resetForm();
            fetchTradePoints();
        } catch (error: any) {
            setAlertOpen({
                status: "error",
                message: error.response?.data?.message || "Ошибка при создании торговой точки",
            });
        }
    }

    async function submitEdit(formikValues: TradePointRequest) {
        try {
            await updateTradePoint(tradePointEditModal.id, formikValues);
            setAlertOpen({
                status: "SUCCESS",
                message: "Торговая точка успешно обновлена",
            });
            setTradePointEditModal(null);
            fetchTradePoints();
        } catch (error: any) {
            setAlertOpen({
                status: "error",
                message: error.response?.data?.message || "Ошибка при обновлении торговой точки",
            });
        }
    }

    async function submitDelete() {
        try {
            await deleteTradePoint(tradePointDelete.id);
            setAlertOpen({
                status: "SUCCESS",
                message: "Торговая точка успешно удалена",
            });
            setTradePointDelete(null);
            fetchTradePoints();
        } catch (error: any) {
            setAlertOpen({
                status: "error",
                message: error.response?.data?.message || "Ошибка при удалении торговой точки",
            });
        }
    }

    // const { isBlocked, proceed } = useAppSelector((state) => state.blocker);
    // let blocker = useBlocker(
    //     ({ currentLocation, nextLocation }) =>
    //         isBlocked !== false && currentLocation.pathname !== nextLocation.pathname,
    // );

    return (
        <div className="flex flex-col w-full">
            <Formik
                initialValues={initialValues}
                onSubmit={(formikValues, { resetForm }) => submitCreate(formikValues, resetForm)}
                enableReinitialize={true}
                validateOnBlur={true}
                validateOnChange={true}
                validationSchema={formValidationSchema}
            >
                {(formik) => {
                    return (
                        <Form className={`w-full mt-[20px] `}>
                            {/* {isBlocked && blocker.state === "blocked" ? (
                                <ModalComponent
                                    isOpen={true}
                                    onClose={() => {
                                        if (blocker && typeof blocker.reset === "function") {
                                            blocker.reset();
                                        }
                                    }}
                                    headerContent={
                                        <div className="flex justify-between">
                                            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px]">
                                                <img src={"/icons/warning.svg"} className="w-[20px]" alt="icon" />
                                                <div className="uppercase">Предупреждение</div>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (blocker && typeof blocker.reset === "function") {
                                                        blocker.reset();
                                                    }
                                                }}
                                                aria-label="Close"
                                                className="float-right cursor-pointer bg-none border-none"
                                            >
                                                &times;
                                            </button>
                                        </div>
                                    }
                                    content={
                                        <>
                                            <div className="flex flex-col gap-[20px]">
                                                <div className="text-base text-gray-600 font-light">
                                                    Вы уверены, что хотите покинуть страницу? Несохраненные данные будут потеряны.
                                                </div>
                                                <div className="flex justify-end gap-[10px]">
                                                    <ModalButton
                                                        type="button"
                                                        onClick={() => {
                                                            if (blocker && typeof blocker.reset === "function") {
                                                                blocker.reset();
                                                            }
                                                        }}
                                                    >
                                                        Отмена
                                                    </ModalButton>
                                                    <ModalButton
                                                        type="button"
                                                        color="green"
                                                        onClick={async () => {
                                                            dispatch(clearBlocker());
                                                            try {
                                                                await submitCreate(formik.values, formik.resetForm);
                                                                if (blocker && typeof blocker.proceed === "function") {
                                                                    blocker.proceed();
                                                                }
                                                            } catch (error) {
                                                                console.error("Error saving data:", error);
                                                            }
                                                        }}
                                                    >
                                                        Сохранить
                                                    </ModalButton>
                                                </div>
                                            </div>
                                        </>
                                    }
                                />
                            ) : null} */}

                            <div className="flex flex-col bg-white my-5 p-5 pt-8 relative rounded-xl shadow-md gap-[20px] overflow-visible">
                                <div
                                    className="flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px]"
                                    onClick={() => setIsOpen1(!isOpen1)}
                                >
                                    <img src="/icons/store.svg" className="w-[20px]" alt="icon" />
                                    <div className="uppercase">Создание торговой точки</div>
                                    <div className={`ml-auto transform transition-transform duration-300 ${isOpen1 ? "rotate-180" : "rotate-0"}`}>
                                        <svg
                                            className="w-6 h-6"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                        </svg>
                                    </div>
                                </div>

                                {isOpen1 && (
                                    <div className="flex flex-col gap-[20px]">
                                        <div className="grid grid-cols-2 gap-[20px]">
                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>Название</label>
                                                    {formik.touched.name && formik.errors.name && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.name === "string" ? formik.errors.name : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    type="text"
                                                    name="name"
                                                    placeholder="Введите название торговой точки"
                                                    className={style.placeholder}
                                                    onChange={(e: any) => {
                                                        formik.handleChange(e);
                                                        dispatch(setBlocker(true));
                                                        setIsFormChanged(true);
                                                    }}
                                                />
                                            </div>

                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>БИН</label>
                                                    {formik.touched.bin && formik.errors.bin && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.bin === "string" ? formik.errors.bin : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    type="text"
                                                    name="bin"
                                                    placeholder="Введите БИН (12 цифр)"
                                                    className={style.placeholder}
                                                    onChange={(e: any) => {
                                                        formik.handleChange(e);
                                                        dispatch(setBlocker(true));
                                                        setIsFormChanged(true);
                                                    }}
                                                />
                                            </div>



                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>Телефон</label>
                                                    {formik.touched.phone && formik.errors.phone && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.phone === "string" ? formik.errors.phone : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    component={InputMask}
                                                    mask="+7 (999) 999-99-99"
                                                    type="text"
                                                    name="phone"
                                                    placeholder="+7 (___) ___-__-__"
                                                    className={style.placeholder}
                                                    value={formik.values.phone}
                                                    onChange={(e: any) => {
                                                        formik.setFieldValue('phone', e.target.value);
                                                    }}
                                                />
                                            </div>

                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>Email</label>
                                                    {formik.touched.email && formik.errors.email && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.email === "string" ? formik.errors.email : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    type="email"
                                                    name="email"
                                                    placeholder="example@mail.com"
                                                    className={style.placeholder}
                                                    onChange={(e: any) => {
                                                        formik.handleChange(e);
                                                        dispatch(setBlocker(true));
                                                        setIsFormChanged(true);
                                                    }}
                                                />
                                            </div>
                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>Адрес</label>
                                                    {formik.touched.address && formik.errors.address && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.address === "string" ? formik.errors.address : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    type="text"
                                                    name="address"
                                                    placeholder="Введите полный адрес"
                                                    className={style.placeholder}
                                                    onChange={(e: any) => {
                                                        formik.handleChange(e);
                                                        dispatch(setBlocker(true));
                                                        setIsFormChanged(true);
                                                    }}
                                                />
                                            </div>
                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>Роль</label>
                                                    {formik.touched.role && formik.errors.role && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.role === "string" ? formik.errors.role : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    component={SelectCustomFormik}
                                                    name="role"
                                                    options={[
                                                        { value: "Поставщик", label: "Поставщик" },
                                                        { value: "Торговая точка", label: "Торговая точка" }
                                                    ]}
                                                    placeholder="Выберите роль"
                                                    className={style.placeholder}
                                                    onChange={(value: any) => {
                                                        formik.setFieldValue('role', value);
                                                        dispatch(setBlocker(true));
                                                        setIsFormChanged(true);
                                                    }}
                                                />
                                            </div>
                                        </div>


                                        <div className="flex justify-end gap-[10px]">
                                            <button
                                                type="button"
                                                className="bg-gray-100 text-gray-500 font-semibold py-2 px-4 rounded hover:bg-gray-200"
                                                onClick={() => {
                                                    formik.resetForm();
                                                    dispatch(clearBlocker());
                                                }}
                                            >
                                                Отмена
                                            </button>
                                            <button
                                                type="submit"
                                                className=" bg-mainColor text-gray-700  font-semibold py-2 px-4 rounded"
                                            >
                                                Создать
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Form>
                    );
                }}
            </Formik>

            {/* Таблица торговых точек */}
            <div className="rounded-lg overflow-x-auto !bg-white shadow-md p-4">
                <table className="max-w-full w-full leading-normal !bg-white">
                    <thead className="border-b-2 border-gray-300 !bg-white">
                        <tr className="">
                            <th className="px-5 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                №
                            </th>
                            <th className="px-5 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                Название
                            </th>
                            <th className="px-5 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                БИН
                            </th>
                            <th className="px-5 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                Адрес
                            </th>
                            <th className="px-5 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                Телефон
                            </th>
                            <th className="px-5 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                                Email
                            </th>

                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {isLoading ? (
                            <tr>
                                <td colSpan={7} className="px-5 py-4">
                                    <div className="flex justify-center items-center">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                                    </div>
                                </td>
                            </tr>
                        ) : tradePointData.length === 0 ? (
                            <tr>
                                <td colSpan={7} className="px-5 py-4 text-center text-gray-500">
                                    Нет данных для отображения
                                </td>
                            </tr>
                        ) : (
                            tradePointData.map((value: any, index: any) => (
                                <tr key={value.id} className="hover:bg-gray-50">
                                    <td className="px-5 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {index + 1}
                                    </td>
                                    <td className="px-5 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {value.name}
                                    </td>
                                    <td className="px-5 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {value.bin}
                                    </td>
                                    <td className="px-5 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {value.address}
                                    </td>
                                    <td className="px-5 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {value.phone}
                                    </td>
                                    <td className="px-5 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {value.email}
                                    </td>
                                    <td className="px-5 py-4 whitespace-nowrap text-sm text-gray-500">
                                        <ActionDropwdownCell
                                            key={`cell-${index}-${value.id}-actions`}
                                            id={value.id}
                                            actions={[
                                                {
                                                    title: "Редактировать",
                                                    action: () => {
                                                        setTradePointEditModal({
                                                            id: value.id,
                                                            name: value.name,
                                                            bin: value.bin,
                                                            address: value.address,
                                                            phone: value.phone,
                                                            email: value.email,
                                                        });
                                                        setActiveTooltipId(null);
                                                    },
                                                },
                                                {
                                                    title: "Пригласить пользователя",
                                                    action: () => {
                                                        navigate(`/tradePoints/${value.id}/invite-user`);
                                                        setActiveTooltipId(null);
                                                    },
                                                },
                                                {
                                                    title: "Удалить",
                                                    action: () => {
                                                        setTradePointDelete({
                                                            id: value.id,
                                                            name: value.name,
                                                        });
                                                        setActiveTooltipId(null);
                                                    },
                                                },
                                            ]}
                                            activeTooltipId={activeTooltipId}
                                            onTooltipToggle={handleTooltipToggle}
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Модальное окно редактирования */}
            {tradePointEditModal && (
                <ModalComponent
                    isOpen={true}
                    onClose={() => setTradePointEditModal(null)}
                    disableBackdropClick={true}
                    headerContent={
                        <div className="flex justify-between">
                            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px]">
                                <img src="/icons/store.svg" className="w-[20px]" alt="icon" />
                                <div className="uppercase">Редактирование торговой точки</div>
                            </div>
                            <button
                                type="button"
                                onClick={() => setTradePointEditModal(null)}
                                aria-label="Close"
                                className="float-right cursor-pointer bg-none border-none"
                            >
                                &times;
                            </button>
                        </div>
                    }
                    content={
                        <Formik
                            initialValues={tradePointEditModal}
                            onSubmit={submitEdit}
                            enableReinitialize={true}
                            validateOnBlur={true}
                            validateOnChange={true}
                            validationSchema={formValidationSchema}
                        >
                            {(formik) => (
                                <Form className="w-full mt-[20px]">
                                    <div className="flex flex-col gap-[20px]">
                                        <div className="grid grid-cols-2 gap-[20px]">
                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>Название</label>
                                                    {formik.touched.name && formik.errors.name && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.name === "string" ? formik.errors.name : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    type="text"
                                                    name="name"
                                                    placeholder="Введите название торговой точки"
                                                    className={style.placeholder}
                                                />
                                            </div>

                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>БИН</label>
                                                    {formik.touched.bin && formik.errors.bin && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.bin === "string" ? formik.errors.bin : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    type="text"
                                                    name="bin"
                                                    placeholder="Введите БИН (12 цифр)"
                                                    className={style.placeholder}
                                                />
                                            </div>



                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>Телефон</label>
                                                    {formik.touched.phone && formik.errors.phone && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.phone === "string" ? formik.errors.phone : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    component={InputMask}
                                                    mask="+7 (999) 999-99-99"
                                                    type="text"
                                                    name="phone"
                                                    placeholder="+7 (___) ___-__-__"
                                                    className={style.placeholder}
                                                    value={formik.values.phone}
                                                    onChange={(e: any) => {
                                                        formik.setFieldValue('phone', e.target.value);
                                                    }}
                                                />
                                            </div>

                                            <div className={style.inputField1}>
                                                <div className={style.labelAndButtonWrapper}>
                                                    <label className={style.inputLabel}>Email</label>
                                                    {formik.touched.email && formik.errors.email && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.email === "string" ? formik.errors.email : "Ошибка"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Field
                                                    type="email"
                                                    name="email"
                                                    placeholder="example@mail.com"
                                                    className={style.placeholder}
                                                />
                                            </div>

                                        </div>
                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <label className={style.inputLabel}>Адрес</label>
                                                {formik.touched.address && formik.errors.address && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.address === "string" ? formik.errors.address : "Ошибка"}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <Field
                                                type="text"
                                                name="address"
                                                placeholder="Введите полный адрес"
                                                className={style.placeholder}
                                            />
                                        </div>

                                        <div className="flex justify-end gap-[10px] h-[40px]">
                                            <button
                                                type="button"
                                                className="bg-gray-100 text-gray-500 font-semibold py-2 px-4 rounded hover:bg-gray-200"
                                                onClick={() => setTradePointEditModal(null)}

                                            >
                                                Отмена
                                            </button>
                                            <button
                                                type="submit"
                                                className=" bg-mainColor text-gray-700  font-semibold py-2 px-4 rounded"
                                            >
                                                Сохранить
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    }
                />
            )}

            {/* Модальное окно удаления */}
            {tradePointDelete && (
                <ModalComponent
                    isOpen={true}
                    onClose={() => setTradePointDelete(null)}
                    content={
                        <div className="w-[600px] bg-white flex flex-col gap-6">
                        <h2 className="text-xl font-semibold text-gray-900">Удалить заказ</h2>
                        <p className="text-gray-700 text-base">
                            Вы уверены, что хотите удалить эту Торговую точку? Это действие нельзя будет отменить.
                        </p>

                    </div>
                    }
                    customContent={
                        <div className="flex flex-col gap-[20px]">
                            
                            <div className="flex justify-end gap-[10px]">
                                <ModalButton
                                    type="button"
                                    color="grey"
                                    onClick={() => setTradePointDelete(null)}
                                >
                                    Отмена
                                </ModalButton>
                                <ModalButton
                                    type="button"
                                    color='mainColor'
                                    onClick={submitDelete}
                                >
                                    Удалить
                                </ModalButton>
                            </div>
                        </div>
                    }
                />
            )}

            {alertOpen && (
                <AlertBox
                    isOpen={alertOpen}
                    setIsOpen={setAlertOpen}
                />
            )}
        </div>
    );
}

export default RegistrationTradePoint;
